<template>
  <div
    class="dc__item dc__changes"
    :class="{ _collapsed: changes.length > 2 && collapsed }"
  >
    <div class="dc-item__label">Изменения документа</div>
    <div v-if="isLoading.changes">Загрузка...</div>

    <div v-else-if="loadErrors.changes.status" class="message _error">
      Ошибка: {{ loadErrors.changes.message }}
    </div>

    <div v-else-if="!changes.length">Нет изменений</div>
    <div v-else class="dc-changes">
      <div v-for="(change, index) in changes" :key="index" class="dc-change">
        <div class="dc-change__number">{{ change.number }}</div>
        <div class="dc-change__wrapper">
          <div class="dc-change__item dc-change__entry-date">
            <span>Введено с {{ change.entryDate }}</span>
          </div>
          <div
            v-if="change.canceledDate"
            class="dc-change__item dc-change__canceled"
          >
            <svg width="20" height="20" class="dc-change__canceled-icon">
              <use xlink:href="#status--disabled" />
            </svg>
            Отменено c {{ change.canceledDate | formatDate }}
          </div>
          <div
            v-else-if="change.isCanceled"
            class="dc-change__item dc-change__canceled"
          >
            <svg width="20" height="20" class="dc-change__canceled-icon">
              <use xlink:href="#status--disabled" />
            </svg>
            Отменено
          </div>
          <div v-if="change.hasText || change.hasScan" class="dc-change__item">
            <router-link
              v-if="change.hasText"
              :to="makeDocumentRoute(change.id)"
              class="dc-change__link"
            >
              <svg width="52" height="26">
                <use xlink:href="#document--text" />
              </svg>
            </router-link>
            <router-link
              v-if="change.hasScan"
              :to="makeDocumentScanRoute(change.id)"
              class="dc-change__link"
            >
              <svg width="52" height="26">
                <use xlink:href="#document--scan" />
              </svg>
            </router-link>
          </div>
          <div
            v-if="change.sourceType || change.sourceNumber"
            class="dc-change__item"
          >
            <span class="snippet__designation">
              {{ change.sourceType }} {{ change.sourceNumber }}
            </span>
          </div>
          <div class="dc-change__item">
            <span>
              Документ утвержден
              <span class="dc-change__highlight">
                {{ change.approvalDate | formatDate }}
              </span>
            </span>
            <span v-if="change.organization">
              организацией «<span class="dc-change__highlight">{{
                change.organization
              }}</span
              >»
            </span>
          </div>
          <div v-if="change.publication" class="dc-change__item">
            <strong>Опубликовано: </strong
            ><span v-html="change.publication"></span>
          </div>
          <div v-if="change.comment" class="dc-change__item">
            <strong>Комментарий:</strong> {{ change.comment }}
          </div>
        </div>
      </div>
      <!-- <div
        v-if="changes.length > 2"
        class="dc__show-more"
        :class="{ '_opened': !collapsed }"
        @click="collapsed = !collapsed"
      > -->
    </div>
    <div v-if="changes.length > 2" class="dc__show-more">
      <a href="#" class="dc-show-more__link" @click="collapsed = false">
        <svg width="12" height="12">
          <use xlink:href="#arrow-sides"></use>
        </svg>
        Показать все изменения ({{ changes.length }})
      </a>
    </div>
    <div v-if="collapsed === false" class="dc__show-more _opened">
      <a href="#" class="dc-show-more__link" @click="collapsed = true">
        <svg width="12" height="12">
          <use xlink:href="#arrow-sides"></use>
        </svg>
        Скрыть изменения
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import apiDocuments from '@src/api/documents';
import DocumentRoute from '@@/document/mixins/DocumentRoute';

export default {
  mixins: [DocumentRoute],

  props: {
    changes: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    collapsed: true
  }),

  computed: {
    ...mapGetters({
      isLoading: 'documentIsLoading',
      loadErrors: 'loadErrors'
    }),
    collapsedText() {
      return this.collapsed
        ? `Показать все изменения (${this.changes.length})`
        : 'Свернуть изменения';
    }
  }
};
</script>
